import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class MailMessageService {
  static getMailMessages(limit = 100, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.MAIL_MESSAGE}?pageSize=${limit}&page=${page}`)
  }

  static getMailMessage(id) {
    return ApiHelper.fetch(`${API.URL + API.MAIL_MESSAGE}/${id}`)
  }
}

export default MailMessageService
